<main-layout [selected]="'REVIEWS'">
    <content>

        <div class="reviews-container">
            <ng-container *ngFor="let review of (reviewsList$ | async)">
                <div class="review-item" (mouseenter)="hoveredId = review.id" (mouseleave)="hoveredId = null">
                    <div class="top-row">
                        <div class="stars">
                            <ng-container *ngFor="let star of [1,2,3,4,5]">
                                <span [class.filled]="star <= review.rating">★</span>
                            </ng-container>
                        </div>
                        <div class="order-info">
                            {{ "reviews_page_order" | translate }} #{{review.orderSlug }}
                            <div class="see-order-link" *ngIf="hoveredId === review.id">                                
                                <a [routerLink]="['/orders', review.orderId]" class="mr-1">Go to order</a>
                                <mat-icon>open_in_new</mat-icon>
                            </div>
                        </div>
                    </div>

                    <div class="date-row">
                        {{ review.createdDate | date: 'dd MMMM yyyy' }}
                    </div>

                    <div class="comment-row">
                        {{ review.comment ? review.comment : ("reviews_page_no_comment" | translate) }}
                    </div>

                </div>

            </ng-container>
        </div>
        
    </content>
</main-layout>
